module.exports = __webpack_public_path__ + "static/media/20.eb8c9cc8.png";